// extracted by mini-css-extract-plugin
module.exports = {"bannerVideo":"banner-video_bannerVideo__1lnih","videoContainer":"banner-video_videoContainer__3FRM4"};